import * as React from "react";
import { __, __BETA } from "src/services/theme";

const HTML = (props) => (
    <section className="info">
    
      <header>
        <div className="container">
          <h1>Free Tata</h1>
          <p>Il tuo profilo professionale su Schoolvisor.<br />
              Scheda completa. <br />
              Scaricabile in PDF per presentare la tua candidatura. <br />
             <strong> Gratis. </strong>
          </p>
        </div>
      </header>
      
      <div className="features container row">
        <div className="icon-free-profile col-xs-12 col-lg-4 col-sm-4 ">
          <div className="center-icon"><span className="icon-resume"></span></div>
          <p>PROFILO COMPLETO</p>
        </div>
        <div className="icon-free-profile col-xs-12 col-lg-4 col-sm-4 ">
          <div className="center-icon"><span className="icon-pdf"></span></div>
          <p>PDF SCARICABILE</p>
        </div>
        <div className="icon-free-profile col-xs-12 col-lg-4 col-sm-4 ">
          <div className="center-icon"><span className="icon-banknotes"></span></div>
          <p>GRATUITO</p>
        </div>
      </div>
     
    {!__BETA && 
     <section> 
        <div className="container-prova-gratis">
          <h3>Aumenta i tuoi contatti</h3>
          <h2>Prova Supertata <strong>gratis </strong> per 30 giorni</h2>
            <button className="button-p-g" onClick={() => props.onClick()}><span>Attiva</span></button>
          <p>Al termine della prova potrai sottoscrivere l’abbonamento annuale a soli 0,99€ al giorno. <br />
                  NON VALIDO PER CHI HA GIA’ USUFRUITO DEL PERIODO DI PROVA</p>
        </div>
    </section>
    }
      
      <div className="faq container">
        <h2><span>Domande frequenti</span></h2>
        <div className="items">
          <article>
            <h4>{__('AcquistiTataFree.faq1_title')}</h4>
            <p>{__('AcquistiTataFree.faq1_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiTataFree.faq2_title')}</h4>
            <p>{__('AcquistiTataFree.faq2_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiTataFree.faq3_title')}</h4>
            <p>{__('AcquistiTataFree.faq3_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiTataFree.faq4_title')}</h4>
            <p>{__('AcquistiTataFree.faq4_text', 130)}</p>
          </article>
        </div>
      </div>
      
    </section>
);

export default HTML;


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiTataInfo/Free.tsx